<template>
  <div class="wf-absolute wf-top-0 wf-w-full wf-overflow-hidden wf-bg-gray-100">
    <div :style="contentWidth">
      <div class="wf-relative wf-w-full">
        <EditorHeader v-if="hasHeader"/>
        <EditorTopInnerSections v-if="hasTopSection"/>
      </div>
      <div class="wf-h-screen wf-bg-gray-100 wf-flex wf-items-center wf-justify-center">
        <h3 class="wf-text-5xl wf-text-gray-600">Page content</h3>
      </div>
      <div>
        <EditorBottomInnerSections v-if="hasBottomSection"/>
        <EditorFooter/>  
      </div>
    </div>
    <component
      v-for="component in components"
      :is="component.slug"
      :component="component"
      :key="component.id"
      parentModule="layoutPageComponentModule"
    ></component>
  </div>
</template>

<script>
  import EditorHeader from './EditorHeader'
  import EditorFooter from './EditorFooter'
  import EditorBottomInnerSections from './EditorBottomInnerSections'
  import EditorTopInnerSections from './EditorTopInnerSections'
  export default {
    components: {
      EditorHeader,
      EditorFooter,
      EditorBottomInnerSections,
      EditorTopInnerSections
    },
    data() {
      return {
        contentWidth: {width: '100%'}
      }
    },
    watch: {
      editingElement() {
        this.calculateContentWidth()
      },
      previewMode() {
        this.calculateContentWidth()
      },
      elementMenuOpen() {
        this.calculateContentWidth()
      },
    },
    mounted() {
      window.addEventListener('resize', this.calculateContentWidth)
    },
    computed: {
      module() {
        return 'layoutModule'
      },
      components() {
        return this.$store.getters['layoutPageComponentModule/elements']()
      },
      hasHeader() {
        return !! this.$store.getters['headerModule/elements']()
      },
      hasTopSection() {
        return !! this.$store.getters['topSectionModule/elements']()
      },
      hasBottomSection() {
        return !! this.$store.getters['bottomSectionModule/elements']()
      },
      previewMode() {
        return this.$store.state.previewMode
      },
      editingElement() {
        return this.$store.state.editingElement
      },
      elementMenuOpen() {
        return this.$store.state.elementToolbar
      },
    },
    methods: {
      calculateContentWidth() {
        if (! this.editingElement || this.previewMode) {
          return this.contentWidth = {width: '100%'}
        }
        if (this.elementMenuOpen) {
          return this.contentWidth = {width: `${window.innerWidth - 320}px` }
        }
        return this.contentWidth = {width: `${window.innerWidth - 72}px` }
      }
    }
  }
</script>